import {makeAutoObservable} from "mobx";
import {ITimelineItemDto} from "../rma-types";
import TimelineItemStore from "./timeline-item-store";
import currentPortalStore from "../../../../stores/current-portal-store";
import {formatDateTimeWithFallback} from "../../../../utilities/timezone-utilities";
import {DATETIME_VIEW} from "../../../../components/datetime-v2/datetime-v2";

interface ITimelineItemsGroup {
    date: string;
    dateForDivider: string;
    items: TimelineItemStore[];
}

class TimelineManagerStore {
    private _timelineItemsGroupList: ITimelineItemsGroup[] = [];
    constructor(timelineItems: ITimelineItemDto[]) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setTimelineItems(timelineItems);
    }
    
    public getGroups(){
        return this._timelineItemsGroupList;
    }
    
    private _setTimelineItems(timelineItems: ITimelineItemDto[]){

        /** In different timezones- two actions that happened on one date in one timezone, can have two dates on other timezone.
         *  In order to group the items according to the correct date, we convert it to locale string, but this removes the hours and minutes from the date,
         *  which causes a bug when we try to use it in the timeline-card component divider.
         *  Therefore, we have two dates on each group:
         *  1. date- which is the converted date to group the items by.
         *  2. dateForDivider- which is the created_at date of the first item in the items group, 
         *     which will appear only in the divider and will  show only the date without the time.
         */
        
        /* group by date */
        timelineItems.forEach(item => {
            const date = this._getFormattedDateForDevider(item.created_at);
            let index = this._timelineItemsGroupList.findIndex((timelineItem) => timelineItem.date === date);
            if (index === -1) {
                this._timelineItemsGroupList.push({date, dateForDivider: item.created_at, items: []});
                index = this._timelineItemsGroupList.length - 1;
            }
            
            this._timelineItemsGroupList[index].items.push(new TimelineItemStore(item));
        });
    }

    private _getFormattedDateForDevider(date: string): string {
        const tzStore = currentPortalStore.setting?.timezoneStore;
        return formatDateTimeWithFallback(tzStore, date, DATETIME_VIEW.DATE_ONLY);
    }
    
}

export default TimelineManagerStore;
